import { urls } from '~/preloaded';
import { get } from '~/helpers/api';
import { actionsHallOfFame } from '~/Actions/ActionHallFame';

import type { AppAsyncThunk } from '~/store';
import type { IApiLadderWinnersResponse } from '~/types/api';

export const getWinners = (): AppAsyncThunk => async (dispatch) => {
  try {
    const url = urls.ladderWinners;
    dispatch(actionsHallOfFame.toggleWinnersFetch(true));

    const response = await get<IApiLadderWinnersResponse>(url);

    if (response.error) {
      throw response.error;
    }

    dispatch(actionsHallOfFame.setWinners(response.winners));
    dispatch(actionsHallOfFame.setOwnRating(response.own_ratings));
  } catch (error: unknown) {
    if (typeof error === 'string') {
      dispatch(actionsHallOfFame.toggleWinnersError(true, error));
    }
  } finally {
    dispatch(actionsHallOfFame.toggleWinnersFetch(false));
  }
};
